import api from '@/services/api'

export default {
    getPurchaseHistory(params) {
        return api.get(`purchase_histories/${params.id}/`, {params})
            .then(response => response.data)
    },
    fetchPurchaseHistory(params) {
        return api.get(`purchase_histories/`, {params})
            .then(response => response.data)
    },
}